var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
        _c("div", { staticClass: "nk-block-between" }, [
          _c("div", { staticClass: "nk-block-head-content" }, [
            _c("h3", { staticClass: "nk-block-title page-title" }, [
              _vm._v(_vm._s(_vm.trans("configuration.configuration"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nk-block-des text-soft" }, [
              _c("p", [_vm._v(_vm._s(_vm.trans("permission.permission")))]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-config-layout admin-linear-page" },
        [
          _c("configuration-sidebar", { attrs: { menu: "permission" } }),
          _vm._v(" "),
          _c("div", { staticClass: "admin-config-panel" }, [
            _c(
              "div",
              {
                staticClass:
                  "admin-config-panel__inner admin-config-panel__inner--wide",
              },
              [
                _c("div", { staticClass: "admin-linear-head" }, [
                  _c("div", [
                    _c("span", { staticClass: "admin-linear-head__eyebrow" }, [
                      _vm._v("Security matrix"),
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "admin-linear-head__title" }, [
                      _vm._v(_vm._s(_vm.trans("permission.permission"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "admin-linear-head__description" }, [
                      _vm._v(
                        "Maintain atomic capabilities and jump into the role assignment matrix when access needs to change."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "admin-linear-stat",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.trans("permission.permission_list"))),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.permissions && _vm.permissions.total
                              ? _vm.permissions.total
                              : 0
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { module: "permission", tip: "tip_permission" },
                }),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "admin-config-list-section",
                    attrs: {
                      "aria-labelledby": "admin-config-permission-list-title",
                    },
                  },
                  [
                    _c(
                      "header",
                      {
                        staticClass:
                          "admin-config-list-head admin-config-list-head--split",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__text" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "admin-config-list-head__title",
                                attrs: {
                                  id: "admin-config-permission-list-title",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.trans("permission.permission_list")
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.permissions && _vm.permissions.total
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "admin-config-list-head__sub",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.trans(
                                            "general.total_result_found",
                                            { count: _vm.permissions.total }
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm.permissions
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "admin-config-list-head__sub admin-config-list-head__sub--empty",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.trans("general.no_result_found")
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__actions" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                attrs: {
                                  to: "/configuration/permission/assign",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.trans("permission.assign_permission")
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName:
                                      "v-b-modal.modal-permission-create",
                                    modifiers: {
                                      "modal-permission-create": true,
                                    },
                                  },
                                ],
                                staticClass:
                                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                attrs: { type: "button" },
                              },
                              [
                                _c("admin-icon", { attrs: { name: "plus" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.trans("general.add_new")) +
                                    "\n                            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.permissions && _vm.permissions.total
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "admin-list-table-card admin-config-list-card",
                          },
                          [
                            _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table admin-data-table admin-data-table--config-list admin-linear-table mb-0",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("permission.name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "admin-table-actions-cell",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.permissions.data,
                                      function (permission) {
                                        return _c(
                                          "tr",
                                          { key: permission.id },
                                          [
                                            _c("td", [
                                              _c(
                                                "strong",
                                                {
                                                  staticClass:
                                                    "admin-linear-primary",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toWord(
                                                        permission.name
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "admin-linear-muted",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(permission.name)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "admin-table-actions-cell",
                                              },
                                              [
                                                _c(
                                                  "table-row-action-dropdown",
                                                  [
                                                    _c(
                                                      "b-dropdown-item-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "confirm",
                                                            rawName:
                                                              "v-confirm",
                                                            value: {
                                                              ok: _vm.confirmDelete(
                                                                permission
                                                              ),
                                                            },
                                                            expression:
                                                              "{ok: confirmDelete(permission)}",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "admin-row-actions__danger",
                                                      },
                                                      [
                                                        _c("admin-icon", {
                                                          attrs: {
                                                            name: "trash",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.trans(
                                                                "permission.delete_permission"
                                                              )
                                                            ) +
                                                            "\n                                                "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "admin-table-pagination-wrap" },
                              [
                                _c("pagination-record", {
                                  attrs: {
                                    "page-length":
                                      _vm.filterPermissionForm.page_length,
                                    records: _vm.permissions,
                                  },
                                  on: {
                                    "update:pageLength": function ($event) {
                                      return _vm.$set(
                                        _vm.filterPermissionForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    "update:page-length": function ($event) {
                                      return _vm.$set(
                                        _vm.filterPermissionForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    updateRecords: _vm.getPermissions,
                                  },
                                  nativeOn: {
                                    change: function ($event) {
                                      return _vm.getPermissions.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.permissions && !_vm.permissions.total
                      ? _c("module-info", {
                          attrs: {
                            module: "permission",
                            title: "module_info_title",
                            description: "module_info_description",
                            icon: "key",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-permission-create",
            "hide-footer": "",
            centered: "",
            lazy: "",
            "modal-class": "admin-modal-pro",
            "content-class": "admin-modal-pro__content",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(_vm._s(_vm.trans("permission.add_new_permission"))),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("permission-form", {
            on: {
              completed: _vm.getPermissions,
              cancel: function ($event) {
                return _vm.$bvModal.hide("modal-permission-create")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }